import { render, staticRenderFns } from "./ColorInput.vue?vue&type=template&id=12c36ea0&"
import script from "./ColorInput.vue?vue&type=script&lang=js&"
export * from "./ColorInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
import { VLabel } from 'vuetify/lib/components/VLabel';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VColorPicker,VLabel,VSheet})
